// extracted by mini-css-extract-plugin
module.exports = {"container":"EventLikedToast_container__Z2INK","message":"EventLikedToast_message__yDdiw","link":"EventLikedToast_link__5tMMe"};